export default __webpack_public_path__ + "static/media/Kitchen-Category-Offer.89d9645e.png";